const topics = [
  { name: '某顶流恋情实锤合集', count: 286, hot: true },
  { name: '暑期档影视剧口碑榜', count: 198, hot: true },
  { name: '网红互撕全记录', count: 354, hot: true },
  { name: '明星翻车名场面', count: 167, hot: false },
  { name: '综艺名场面盘点', count: 243, hot: true },
  { name: '年度音乐榜单揭晓', count: 132, hot: false },
  { name: '品牌代言人变更动态', count: 112, hot: false },
  { name: '社会热点深度吃瓜', count: 421, hot: true },
  { name: '海外娱乐圈动态', count: 89, hot: false },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-2">
          专题瓜田汇总
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">按话题分类浏览，精准定位你的吃瓜兴趣</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {topics.map((topic, i) => (
            <div
              key={i}
              className="group flex items-center gap-4 bg-background-50 rounded-lg border border-background-200/70 p-4 hover:border-primary-200/50 transition-all cursor-pointer"
            >
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${
                i % 3 === 0 ? 'bg-primary-100 text-primary-600' :
                i % 3 === 1 ? 'bg-accent-100 text-accent-600' :
                'bg-secondary-100 text-secondary-600'
              }`}>
                <i className={`${
                  i === 0 ? 'ri-heart-line' :
                  i === 1 ? 'ri-film-line' :
                  i === 2 ? 'ri-live-line' :
                  i === 3 ? 'ri-emotion-laugh-line' :
                  i === 4 ? 'ri-tv-line' :
                  i === 5 ? 'ri-music-line' :
                  i === 6 ? 'ri-star-line' :
                  i === 7 ? 'ri-fire-line' :
                  'ri-global-line'
                } text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 truncate">{topic.name}</h3>
                <p className="text-xs text-foreground-400 mt-0.5">{topic.count}篇相关内容</p>
              </div>
              {topic.hot && (
                <span className="flex-shrink-0 px-2 py-0.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full">
                  热门
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}